//src/components/Sidebar.jsx

import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { isAdmin } from "./AuthService";
import { SQL_STUDIO_ROUTE, SQL_STUDIO_LABEL } from "../sql-studio/constants";

function Sidebar({ open = false, collapsed = false, onNavigate }) {
  const location = useLocation();
  const isReportingPath = location.pathname.startsWith("/reporting");
  const isApnaClinicPath = location.pathname.startsWith("/Pages/ApnaClinic");
  const [reportingOpen, setReportingOpen] = useState(isReportingPath);
  const [apnaClinicOpen, setApnaClinicOpen] = useState(isApnaClinicPath);

  const handleNav = () => {
    if (typeof onNavigate === "function") onNavigate();
  };

  const isActive = (path) =>
    location.pathname === path || location.pathname.startsWith(`${path}/`);

  return (
    <aside
      className={`sidebar${open ? " open" : ""}${collapsed ? " collapsed" : ""}`}
      aria-label="Main navigation"
      aria-hidden={collapsed}
    >
      <nav className="sidebar-nav">
        <ul className="sidebar-menu">
          <li>
            <Link
              to="/dashboard"
              className={isActive("/dashboard") ? "active" : ""}
              onClick={handleNav}
            >
              Dashboard
            </Link>
          </li>

          {isAdmin() && (
            <li>
              <Link
                to="/account/users"
                className={isActive("/account/users") ? "active" : ""}
                onClick={handleNav}
              >
                Users
              </Link>
            </li>
          )}

          <li>
            <Link
              to={SQL_STUDIO_ROUTE}
              className={isActive(SQL_STUDIO_ROUTE) ? "active" : ""}
              onClick={handleNav}
            >
              {SQL_STUDIO_LABEL}
            </Link>
          </li>

          <li>
            <Link
              to="/tools/office-projects"
              className={isActive("/tools/office-projects") ? "active" : ""}
              onClick={handleNav}
            >
              Office Projects
            </Link>
          </li>

          <li className={`sidebar-dropdown ${reportingOpen ? "open" : ""}`}>
            <button
              type="button"
              className="sidebar-dropdown-toggle"
              onClick={() => setReportingOpen((prev) => !prev)}
            >
              <span>Reporting</span>
              <i className={`bi bi-chevron-${reportingOpen ? "up" : "down"}`}></i>
            </button>
            {reportingOpen && (
              <ul className="sidebar-submenu">
                <li>
                  <Link
                    to="/reporting/call-logs"
                    className={isActive("/reporting/call-logs") ? "active" : ""}
                    onClick={handleNav}
                  >
                    Call Logs
                  </Link>
                </li>
                <li>
                  <Link
                    to="/reporting/dailer-recording"
                    className={isActive("/reporting/dailer-recording") ? "active" : ""}
                    onClick={handleNav}
                  >
                    Dailer Recording
                  </Link>
                </li>
                <li>
                  <Link
                    to="/reporting/consultation-report"
                    className={isActive("/reporting/consultation-report") ? "active" : ""}
                    onClick={handleNav}
                  >
                    Consultation Report
                  </Link>
                </li>
                <li>
                  <Link
                    to="/reporting/tabeeb"
                    className={isActive("/reporting/tabeeb") ? "active" : ""}
                    onClick={handleNav}
                  >
                    Tabeeb Reporting
                  </Link>
                </li>
              </ul>
            )}
          </li>

          <li>
            <Link
              to="/blogs"
              className={isActive("/blogs") ? "active" : ""}
              onClick={handleNav}
            >
              Blogs
            </Link>
          </li>
          <li>
            <Link
              to="/Pages/BulkRegistration_Dashboard"
              className={isActive("/Pages/BulkRegistration_Dashboard") || isActive("/Pages/BulkRegistrationReport") ? "active" : ""}
              onClick={handleNav}
            >
              Bulk Registration
            </Link>
          </li>
          <li className={`sidebar-dropdown ${apnaClinicOpen ? "open" : ""}`}>
            <button
              type="button"
              className="sidebar-dropdown-toggle"
              onClick={() => setApnaClinicOpen((prev) => !prev)}
            >
              <span>ApnaClinic</span>
              <i className={`bi bi-chevron-${apnaClinicOpen ? "up" : "down"}`}></i>
            </button>
            {apnaClinicOpen && (
              <ul className="sidebar-submenu">
                <li>
                  <Link
                    to="/Pages/ApnaClinic"
                    className={location.pathname === "/Pages/ApnaClinic" ? "active" : ""}
                    onClick={handleNav}
                  >
                    Blocked Numbers
                  </Link>
                </li>
                <li>
                  <Link
                    to="/Pages/ApnaClinic/pbx-4455-sync"
                    className={isActive("/Pages/ApnaClinic/pbx-4455-sync") ? "active" : ""}
                    onClick={handleNav}
                  >
                    PBX 4455 Sync
                  </Link>
                </li>
              </ul>
            )}
          </li>
          <li>
            <Link to="#" onClick={(e) => e.preventDefault()}>
              Products
            </Link>
          </li>
        </ul>
      </nav>
    </aside>
  );
}

export default Sidebar;
